module.exports = __webpack_public_path__ + "static/img/knives22.f391a84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/knives22.jpg
// module id = JhKc
// module chunks = 0